import { render } from "./master_fields_input.vue?vue&type=template&id=20c57750"
import script from "./master_fields_input.vue?vue&type=script&lang=js"
export * from "./master_fields_input.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/input/master_fields_input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20c57750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20c57750', __exports__)) {
    api.reload('20c57750', __exports__)
  }
  
  module.hot.accept("./master_fields_input.vue?vue&type=template&id=20c57750", () => {
    api.rerender('20c57750', render)
  })

}


export default __exports__